/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import {
  propTypesAltLanguage,
  propTypesIllustration,
} from '../../shared/constants/Proptypes';

export const propTypesNewsletter = {
  alternate_languages: PropTypes.shape(propTypesAltLanguage),
  data: PropTypes.shape({
    breadcrumb_title: PropTypes.string,
    illustration: PropTypes.shape(propTypesIllustration),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    og_description: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        sendinblue_list_id: PropTypes.string,
        custom_title: PropTypes.string,
        custom_description: PropTypes.string,
        custom_illustration: PropTypes.shape(propTypesIllustration),
      })
    ),
  }),
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  last_publication_date: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  uid: PropTypes.string,
};
